/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { ArrowBack } from '@mui/icons-material';
import { Box, Button, TextField } from '@mui/material';
import { isNil } from 'lodash';

import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectExportViewTitle, selectMissionPlanById } from '../../../../store';
import { setExportViewTitle } from '../../../../store/ui/actions';
import { formatPOExportMissoinCreatedDate } from '../../../../utils/DateTimeUtils';
import MenuItems from '../../../common/layout/menu/MenuItems';
import appTheme from '../../../common/theme/appTheme.json';

const PerformanceOutlookExportHeader = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const mission = useSelector(selectMissionPlanById, shallowEqual);
  const exportViewTitle = useSelector(selectExportViewTitle, shallowEqual);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        backgroundColor: appTheme.primaryBackgroundColor,
        zIndex: 1,
        paddingBottom: '10px',
        paddingTop: '10px',
        width: '100%',
        height: '56px',
        display: 'flex',
        marginTop: '20px',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        '@media print': {
          display: 'none',
        },
      }}
    >
      <Box>
        <Button
          disableRipple
          color="primary"
          size="large"
          variant="text"
          sx={{}}
          onClick={() => {
            history.push(`/${MenuItems.plans}/performance-outlook`);
          }}
          startIcon={<ArrowBack />}
        >
          Performance Outlook
        </Button>
      </Box>
      <Box sx={{ flexGrow: 1, paddingX: '16px' }}>
        <TextField
          fullWidth
          id="export-title-id"
          variant="outlined"
          placeholder="Enter export title"
          value={exportViewTitle}
          onChange={e => {
            dispatch(setExportViewTitle(e?.target?.value || ''));
          }}
          sx={{
            input: {
              color: 'white',
              fontSize: appTheme.defaultFontSize,
              fontFamily: appTheme.appFontFamily,
            },
            fieldset: { borderColor: '#7F8487', borderRadius: 2 },
          }}
        />
      </Box>
      <Box sx={{}}>
        <Button
          variant="contained"
          size="large"
          sx={{
            border: 'none',
            backgroundColor: appTheme.mptLightBlue,
            color: appTheme.textLightModeColor,
            '&:hover': {
              backgroundColor: appTheme.mptLightBlue,
            },
          }}
          onClick={() => {
            if (!isNil(mission?.creationDate)) {
              window.document.title = `${
                exportViewTitle || 'Mission Planning Export'
              } - ${formatPOExportMissoinCreatedDate(mission.creationDate)}Z`;
            } else {
              window.document.title = `${exportViewTitle || 'Mission Planning Export'}`;
            }

            window.print();

            window.document.title = 'Viasat Unified Portal';
          }}
        >
          Print
        </Button>
      </Box>
    </Box>
  );
};

export default PerformanceOutlookExportHeader;
